export const volumeMute = {
	className: 'icon-volume-mute',
	viewBox: '0 0 192 351.08499',
	paths: ['m 0,111.542 0,128 85.334,0 L 192,351.085 192,0 85.334,111.542 0,111.542 Z']
}
